import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { getStoredQueryParams } from 'utils/analyticsHelpers';
import { QUERY_PARAMS } from 'consts';
import { GlobalContextType } from 'types';
import { triadSuperFetch } from 'utils/superFetch';

const { SHARED_EDU_ID, SHARED_SESSION_ID } = QUERY_PARAMS;

interface UserProfile {
  profile: {
    questionAnswer: string;
    questionId: string;
  }[];
}

export async function getUserProfile(
  taxonomyValues: GlobalContextType['taxonomyValues']
): Promise<UserProfile> {
  const parentCategoryGuid = taxonomyValues?.parentCategories[0];
  const queryParamsHelper = getStoredQueryParams();
  const queryParamMap = queryParamsHelper.queryParamMap as Record<
    string,
    string
  >;

  const [apiError, response] = await triadSuperFetch<UserProfile>(
    `${TRIAD_PROXY_ROUTE}/userProfile`,
    {
      method: 'POST',
      body: {
        parentCategoryGuid,
        [SHARED_EDU_ID]: queryParamMap[SHARED_EDU_ID],
        [SHARED_SESSION_ID]: queryParamMap[SHARED_SESSION_ID],
        includeGeoLocation: false,
      },
      timeout: 5000,
    }
  );

  if (apiError) {
    return {
      profile: [],
    };
  }

  return response;
}
